module.exports = __webpack_public_path__ + "img/clioLogo.baae633f.svg";